/**
 * Which pages work one store at a time.
 *
 * The top bar can look at one store or at "All stores" (the brand's totals; owner 2026-10-28). Most pages
 * answer for the whole brand when no single store is picked. The pages below cannot: they edit or count one
 * store's own things, or the report behind them belongs to one store. While "All stores" is picked they leave
 * the menu, the page search and the home cards, and opening one anyway (a bookmark, the back button, the
 * assistant) shows "Pick a store" in its place, so nothing on them ever runs without a real store.
 *
 * Add a page here when it needs a single store. Everything else is expected to cope with "All stores".
 */
export const ONE_STORE_PAGES = new Set([
  // A shift is opened and closed at one till; the report has no date to add up across stores.
  "analytics-shift",
  // Each store has its own banners.
  "banners",
  // A coupon's products are picked from one store's menu (the coupon list itself is the same from every store).
  "coupons",
  // A store's menus, products and toppings, and the store's own copies of the brand's.
  "menus",
  "products",
  "option-items",
  // Stock is held, counted, delivered, wasted and reordered per store ("All stores" under Inventory is the overview).
  "stock-onhand",
  "stock-count",
  "stock-deliveries",
  "stock-waste",
  "stock-reorder",
  // The old Invorest pages (hidden in the menu), should they ever come back.
  "stocks",
  "stock-audits",
  "stock-reducted-reports",
  "stock-added-reports",
  // Branch Settings: opening hours, delivery zones and till users belong to one store.
  "working-hours",
  "delivery-map",
  "pos-users",
]);

/** True when the page named `name` needs a single store. */
export function needsOneStore(name) {
  return ONE_STORE_PAGES.has(name);
}
